
import { defineComponent } from 'vue';
import "bootstrap";
import "bootstrap-icons/font/bootstrap-icons.scss";

import AppHeader from "@/components/AppHeader.vue";
import AppFooter from "@/components/AppFooter.vue";
import AppNotifications from '@/components/AppNotifications.vue';
import * as version from "@/assets/version.json";

export default defineComponent({
  setup() {
    // eslint-disable-next-line
    const currentVersion = (version.default as any)["wv"].toString();
    const lastVersion = (localStorage.getItem("current-version"))?.toString();

    if (lastVersion !== currentVersion) {
      localStorage.setItem("current-version", currentVersion);
      window.location.reload();
    }
  },
  components: {
    AppHeader,
    AppFooter,
    AppNotifications,
  },
});
